import { mapActions, mapGetters } from "vuex";
import WithRender from "../../templates/base/summaryFooter.html";
import { i18n } from "../../i18n.js";

export default WithRender({
  computed: {
    ...mapGetters([
      "getQuantity",
      "getChangeOptionsData",
      "getExpressProduction",
      "getDefaultProduction",
      "getIsMobile",
      "getDeliveryDate",
      "getBaseUrl",
      "getIsSummaryFooterExpanded",
      "getIsProductionSpeedHidden",
      "getSelectedQuantityFormattedBasePrice",
      "getFileCopyChecked"
    ]),
    getFooterQuantity: function () {
      let quantity = parseInt(this.getQuantity);
      if (this.getFileCopyChecked) {
        quantity += 1;
      }
      return quantity;
    },
    getTodaysDate: function () {
      return new Date().toLocaleDateString("en-GB");
    },
    getDespatchText: function () {
      return i18n.t(
        "Est. Despatch: {deliveryDate} if ordered before 4PM {todaysDate}",
        {
          deliveryDate: this.getDeliveryDate,
          todaysDate: this.getTodaysDate
        }
      );
    }
  },
  methods: {
    ...mapActions(["setProductionSpeed", "setIsSummaryFooterExpanded"]),
    handleClickExpressCheckbox: function (event) {
      const expressProductionLabel = this.getExpressProduction;
      const defaultProductionLabel = this.getDefaultProduction;
      if (event.target.checked) {
        if (expressProductionLabel) {
          this.setProductionSpeed(expressProductionLabel);
        }
      } else {
        if (defaultProductionLabel) {
          this.setProductionSpeed(defaultProductionLabel);
        }
      }
    },
    toggleSummaryFooter: function () {
      this.summaryFooterMinimized = !this.summaryFooterMinimized;
    }
  }
});
